import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { BsEye, BsPencilSquare, BsTrash } from "react-icons/bs";

interface Item {
  id: number;
  post_date: string;
  event_date_end: string;
  title: string;
  author: string;
  status: string;
}

interface currentLatestTableProps {
  items: Item[];
  onView: (id: number) => void;
  onEdit: (id: number) => void;
  onDelete: (id: number) => void;
}

export default function CurrentLatestTable({
  items,
  onView,
  onEdit,
  onDelete,
}: currentLatestTableProps) {
  const [latestPage, setLatestPage] = useState(1);
  const latestPerPage = 10;

  const approvedItems = items.filter((item) => item.status === "Approved");
  const totalPages = Math.ceil(approvedItems.length / latestPerPage);

  const indexOfLastLatest = latestPage * latestPerPage;
  const indexOfFirstLatest = indexOfLastLatest - latestPerPage;
  const currentLatest = approvedItems.slice(
    indexOfFirstLatest,
    indexOfLastLatest
  );

  const nextLatestPage = () => {
    if (latestPage < totalPages) {
      setLatestPage(latestPage + 1);
    }
  };

  const prevLatestPage = () => {
    if (latestPage > 1) {
      setLatestPage(latestPage - 1);
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [latestPage]);

  return (
    <>
      <Table hover>
        <thead className="bg-gray-200">
          <tr>
            <th>Post Date</th>
            <th>Event End</th>
            <th>Title</th>
            <th>Author</th>
            <th>Status</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {currentLatest.map((item) => (
            <tr key={item.id}>
              <td>{item.post_date}</td>
              <td>{item.event_date_end}</td>
              <td>{item.title}</td>
              <td>{item.author}</td>
              <td>{item.status}</td>
              <td>
                <button
                  onClick={() => onEdit(item.id)}
                  className="bg-red-600 rounded-sm text-white text-xl mr-2"
                  data-tooltip-id="edit"
                >
                  <BsPencilSquare />
                </button>
                <button
                  onClick={() => onDelete(item.id)}
                  type="button"
                  className="bg-gray-600 rounded-sm text-white text-xl"
                  data-tooltip-id="delete"
                >
                  <BsTrash />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* Pagination Controls */}
      <div className="flex justify-center items-center mt-4 space-x-2">
        <button
          onClick={prevLatestPage}
          className="px-3 py-1 rounded disabled:opacity-50 text-white bg-gray-500"
          disabled={latestPage === 1}
        >
          Prev
        </button>

        {[...Array(totalPages)].map((_, index) => {
          const pageNum = index + 1;
          return (
            <button
              key={pageNum}
              onClick={() => setLatestPage(pageNum)}
              className={`px-3 py-1 rounded ${
                latestPage === pageNum
                  ? "bg-red-600 text-white"
                  : "bg-gray-200 text-black"
              }`}
            >
              {pageNum}
            </button>
          );
        })}

        <button
          onClick={nextLatestPage}
          className="px-3 py-1 rounded disabled:opacity-50 text-white bg-red-500"
          disabled={latestPage === totalPages}
        >
          Next
        </button>
      </div>
    </>
  );
}
